import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Lottie from "lottie-react";
import moment from "moment";
import BackIcon from "./common/BackIcon";
import * as loadingDots from "../animations/loading-dots.json";
import { getBDSForBedAppointment, getBedDayStatuses } from "./services/soar";
import { getFieldName, getFieldDate } from "../scripts/helperScripts";

const BedDayStatuses = () => {
  const location = useLocation();
  const [loadStatus, setLoadStatus] = useState({});
  const [bedDayStatuses, setBedDayStatuses] = useState([]);

  const { contactName, bedId, bedName, bedAppointmentId } = location.state || {};

  useEffect(() => {
    const controller = new AbortController();

    if (!loadStatus.loaded && (bedId || bedAppointmentId)) {
      setLoadStatus((ls) => {
        return { ...ls, loading: true }
      })
      const loadBedDayStatuses = async () => {
        const signal = controller.signal;
        let results;

        if (bedId) {
          results = await getBedDayStatuses(bedId, signal);
        } else if (bedAppointmentId) {
          results = await getBDSForBedAppointment(bedAppointmentId, signal);
        }

        if (!signal.aborted) {
          if (results) {
            setBedDayStatuses(
              results.sort((a, b) => {
                const aDate = moment(getFieldDate(a.ccx_startdate));
                const bDate = moment(getFieldDate(b.ccx_startdate));
                if (aDate > bDate) return -1;
                if (aDate < bDate) return 1;
                return 0;
              })
            );
          }

          setLoadStatus((ls) => {
            return { ...ls, loading: false, loaded: true }
          })
        }
      };

      loadBedDayStatuses();
    }

    return () => {
      controller.abort();
    };
  }, [bedId, bedAppointmentId, loadStatus.loaded]);

  return (
    <>
      <BackIcon />
      {loadStatus.loaded ? (
        <>
          <div className="mt-2 h6">
            Bed Day Statuses for {bedName} with {contactName}
          </div>
          {bedDayStatuses.length > 0 ? (
            <div className="container border mt-2">
              <div className="row border-bottom">
                <div className="col py-2 text-center border-end">
                  Bed Status Date
                </div>
                <div className="col py-2 text-center border-end">
                  Service Status
                </div>
                <div className="col-1 py-2 text-center"></div>
              </div>
              {bedDayStatuses.map((bds) => {
                return (
                  <div
                    key={bds.ccx_beddaystatusid}
                    className="row border-bottom"
                    style={
                      getFieldName(bds.ccx_clinicallyvoided) !== "Yes" &&
                        getFieldName(bds.ccx_confirmed) === "Yes"
                        ? { backgroundColor: "rgba(40, 167, 69, .5)" }
                        : {}
                    }
                  >
                    <div className="col py-2 border-end">
                      {moment(getFieldDate(bds.ccx_startdate)).format("l")}
                    </div>
                    <div className="col py-2 border-end">
                      {getFieldName(bds.ccx_servicestatuslookup)}
                    </div>
                    <div className="col-1 py-2">
                      <i
                        className={`btn btn-link btn-safy-link fas fa-pen p-2 ${getFieldName(bds.ccx_clinicallyvoided) !== "Yes" &&
                          getFieldName(bds.ccx_confirmed) === "Yes"
                          ? "text-white"
                          : "text-primary"
                          }`}
                        onClick={() => {
                          window.open(
                            `${process.env.REACT_APP_ORG}/main.aspx?etn=ccx_beddaystatus&id=${bds.ccx_beddaystatusid}&newWindow=true&pagetype=entityrecord`
                          );
                        }}
                      ></i>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="fw-bold text-primary">
              <u>No records found</u>
            </div>
          )}
        </>
      ) : loadStatus.loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <h1>LOADING BED DAY STATUSES</h1>
          <Lottie
            animationData={loadingDots.default}
            loop={true}
            autoplay={true}
            rendererSettings={{
              preserveAspectRatio: "xMidYMid slice",
            }}
            height={120}
            width={120}
          />
        </div>
      ) : null}
    </>
  );
};

export default BedDayStatuses;
